import { useEffect, useState } from "react";
import { LabelText, LittleText } from "../typography";
import Dropdown from "./dropdown";
import { DropdownTypeEnum } from "../../assets/utils/enums/table";
import styled from "styled-components";
import { COLORS } from "../../assets/utils/enums/colors";
import { months } from "../../assets/utils/date-formatter";

interface DeadlinePickerProps {
  label?: string;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}

export default function DeadlinePicker({ label, value, setValue }: DeadlinePickerProps) {
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const years = Array.from({ length: 5 }, (_, i) =>
    (new Date().getFullYear() + i).toString()
  );

  function isLeapYear(year: number) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  function getDaysInMonth(month: string, year: string) {
    if (!month || !year) return 31;

    const monthIndex = months.indexOf(month);

    if (monthIndex === 1) {
      return isLeapYear(Number(year)) ? 29 : 28;
    }

    return [3, 5, 8, 10].includes(monthIndex) ? 30 : 31;
  }


  const maxDays = getDaysInMonth(month, year);
  const days = Array.from({ length: maxDays }, (_, i) => (i + 1).toString());

  useEffect(() => {
    if (!value) return;
    const [d, m, y] = value.split(" ");
    setDay(d);
    setMonth(m);
    setYear(y);
  }, [value]);

  useEffect(() => {
    if (!day) return;

    const maxDays = getDaysInMonth(month, year);

    if (Number(day) > maxDays) {
      setDay(maxDays.toString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [month, year]);


  useEffect(() => {
    if (!day || !month || !year) return;

    const maxDays = getDaysInMonth(month, year);
    if (Number(day) > maxDays) return;

    setValue(`${day} ${month} ${year}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [day, month, year]);


  return (
    <DeadlineWrapper>
      <LabelText>{label ?? "Дедлайн"}</LabelText>
      <div className="pickers">
        <Dropdown type={DropdownTypeEnum.DATE} checkedValue={day || "День"} setChecked={setDay} numberArray={days} />
        <Dropdown type={DropdownTypeEnum.DATE} checkedValue={month || "Місяць"} setChecked={setMonth} numberArray={months} />
        <Dropdown type={DropdownTypeEnum.DATE} checkedValue={year || "Рік"} setChecked={setYear} numberArray={years} />
      </div>
    </DeadlineWrapper>
  );
}


const DeadlineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0;

  ${LabelText} {
    padding-bottom: 8px;
    padding-left: 20px;
    color: ${COLORS.secondary1};
  }
  ${LittleText} {
    border-radius: 12px;
  }
  .pickers {
    display: flex;
    gap: 12px;

    > div {
      flex: 1;
    }
  }
`;
